import React, { useCallback } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { UnknownObject } from '../../../../../../../react-app-env';

import {
  TextField,
} from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import { SenderUser, EnumSenderType, ValidationErrors, validationErrors, SenderUserReducerAction } from '../..';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>,
  user: SenderUser,
  userTypes: EnumSenderType[],
  errors: ValidationErrors,
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>,
  dispatch: React.Dispatch<{ type: SenderUserReducerAction, value: any }>,
}

const StepUserRole = ({ classes, user, userTypes = [], errors, setErrors, dispatch }: Props): React.ReactElement => {
  const validate = useCallback(() => {
    const errorItems: UnknownObject = {}
    errorItems.user_role = !user.sender_type ? validationErrors.user_role : false;
    setErrors({...errors, ...errorItems});
  }, [user, errors, setErrors]);

  return (
    <>
      <div className={classes.root}>
        <Autocomplete
          data-qa="user-role-list"
          options={userTypes}
          getOptionLabel={(option: EnumSenderType) => option.description}
          value={userTypes.find(i => i.sender_type === user.sender_type)}
          autoComplete
          onBlur={() => validate()}
          onChange={(_: unknown, newValue: EnumSenderType | null) => {
            const value = newValue ? newValue.sender_type : '';
            dispatch({ type: SenderUserReducerAction.USER_ROLE, value });
          }}
          renderInput={(params) =>
            <TextField
              data-qa="user-role-input"
              {...params}
              label="User role"
              name="user-role"
              error={errors.user_role as boolean}
              helperText={errors.user_role} />}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(StepUserRole);
